import { FlaskConical } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { toErrorMessage } from '@/shared/api';
import { Button } from '@/shared/components/ui/button';
import { Separator } from '@/shared/components/ui/separator';
import { toast } from '@/shared/components/ui/toaster';
import { ROUTES } from '@/shared/constants/routes';

import { useDemoLogin, useDemoStatus } from '../api/demo.api';

/**
 * The demo entry point on the login screen.
 *
 * Rendered only when the server reports the demo door open, so a production
 * deployment with `DEMO_MODE=false` shows nothing at all — there is no client
 * flag to forget to flip.
 */
export function DemoLoginButton() {
  const navigate = useNavigate();
  const status = useDemoStatus();
  const demoLogin = useDemoLogin();

  if (!status.data?.enabled) return null;

  const start = async () => {
    try {
      await demoLogin.mutateAsync();
      void navigate(ROUTES.demo, { replace: true });
    } catch (error) {
      toast.error(toErrorMessage(error));
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Separator className="flex-1" />
        <span className="text-muted-foreground text-xs">یا</span>
        <Separator className="flex-1" />
      </div>

      <Button
        type="button"
        variant="outline"
        block
        size="lg"
        loading={demoLogin.isPending}
        onClick={() => void start()}
      >
        <FlaskConical className="size-4" />
        ورود به نسخه نمایشی (بدون کد تأیید)
      </Button>

      <p className="text-muted-foreground text-center text-xs leading-relaxed">
        برای بررسی جریان برنامه و پرداخت آزمایشی، بدون نیاز به شماره موبایل.
      </p>
    </div>
  );
}
